var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgISignupFail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "buttonGloss",
    x1: 60,
    y1: 9,
    x2: 60,
    y2: 83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "minusFill",
    x1: 60,
    y1: 49,
    x2: 60,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE1E8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "buttonShadow",
    x: -8,
    y: -4,
    width: 136,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 5,
    floodColor: "#69000E",
    floodOpacity: 0.32
  })), /*#__PURE__*/React.createElement("filter", {
    id: "minusShadow",
    x: 21,
    y: 40,
    width: 78,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 4,
    floodColor: "#720010",
    floodOpacity: 0.48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#buttonShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 57,
    r: 51,
    fill: "#E55151"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 57,
    r: 50.5,
    stroke: "#C13F3F",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 44,
    rx: 46,
    ry: 34,
    fill: "url(#buttonGloss)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 77C24 94 40 106 60 107C80 107 98 95 104 77C96 91 80 99 60 99C40 99 25 91 17 77Z",
    fill: "#9E3232",
    fillOpacity: 0.12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#minusShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 49,
    width: 62,
    height: 20,
    rx: 4,
    fill: "url(#minusFill)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 49.5,
    width: 61,
    height: 19,
    rx: 3.5,
    stroke: "white",
    strokeOpacity: 0.76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgISignupFail);
export default __webpack_public_path__ + "static/media/i_signup_fail.7c38b1b9f9e75c5fd880c1c7ea713922.svg";
export { ForwardRef as ReactComponent };